import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import injectSheet from 'react-jss'
import styles from './moderation.styles'
import TabNav from './tab-nav/tab-nav.container'
import Paper from 'pobble-components/dist/paper'
import CurrentInvitations from './current-invitations/current-invitations.container'
import ArchivedInvitations from './archived-invitations/archived-invitations.container'
import MyFiles from './my-files/my-files.container'
import ArchivedFiles from './archived-files/archived-files.container'
import SchoolFiles from './school-files/school-files.container'
import OrganisationFiles from './organisation-files/organisation-files.container'
import Examples from './examples/examples.container'
import Trainings from './trainings/trainings.container'
import Support from './support/support'
import WorkWithModerator from './work-with-moderator/work-with-moderator'
import Button from 'pobble-components/dist/button'
import PlusIcon from 'react-icons/lib/fa/plus-circle'

class Moderation extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, canManageAFs } = this.props
    return (
      <div className={classes.page}>
        <header className={classes.head}>
          <h1 className={classes.title}>Moderation</h1>
          {canManageAFs && (
            <Button href="/dashboard" tall simple className={classes.plus}>
              <PlusIcon /> New{' '}
              <span className={classes.hideMobile}>&nbsp;moderation file</span>
            </Button>
          )}
        </header>
        <Paper className={classes.paper}>
          <TabNav />
          <div className={classes.tabContainer}>
            <Route exact path="/" component={Support} />
            <Route exact path="/invitations" component={CurrentInvitations} />
            <Route
              path="/invitations/archived"
              component={ArchivedInvitations}
            />
            <Route exact path="/my-files" component={MyFiles} />
            <Route path="/my-files/archived" component={ArchivedFiles} />
            <Route path="/school" component={SchoolFiles} />
            <Route path="/writing-samples" component={Examples} />
            <Route path="/examples" component={Examples} />
            <Route path="/trainings" component={Trainings} />
            <Route path="/local-authority" component={OrganisationFiles} />
            <Route path="/support" component={Support} />
            <Route
              path="/work-with-a-moderator"
              component={WorkWithModerator}
            />
          </div>
        </Paper>
      </div>
    )
  }
}

export default injectSheet(styles)(Moderation)
